import { render, staticRenderFns } from "./ItemInfo.vue?vue&type=template&id=45955e97&scoped=true"
import script from "./ItemInfo.vue?vue&type=script&lang=js"
export * from "./ItemInfo.vue?vue&type=script&lang=js"
import style0 from "./ItemInfo.vue?vue&type=style&index=0&id=45955e97&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45955e97",
  null
  
)

export default component.exports